import { render, staticRenderFns } from "./SVGLib.vue?vue&type=template&id=4e440acf&scoped=true&"
import script from "./SVGLib.vue?vue&type=script&lang=js&"
export * from "./SVGLib.vue?vue&type=script&lang=js&"
import style0 from "./SVGLib.vue?vue&type=style&index=0&id=4e440acf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e440acf",
  null
  
)

export default component.exports